import { type APIResponse, type IncidentTypeCategory } from "@/lib/types";
import { authenticatedFastApiAxiosInstance } from "../../http";
import { baseFastApiMatterRoute } from "./matter";

export const retrieveIncidentTypeCategoriesV2 = () => {
  return authenticatedFastApiAxiosInstance
    .get<
      APIResponse<IncidentTypeCategory[]>
    >(`${baseFastApiMatterRoute}/incident-type-categories`)
    .then((res) => res.data);
};
